import { render, staticRenderFns } from "./NotificationComp.vue?vue&type=template&id=63367b7f"
import script from "./NotificationComp.vue?vue&type=script&lang=js"
export * from "./NotificationComp.vue?vue&type=script&lang=js"
import style0 from "./NotificationComp.vue?vue&type=style&index=0&id=63367b7f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports